import {
  AfterViewInit,
  Component,
  EventEmitter,
  forwardRef,
  Host,
  Input,
  OnInit,
  Optional,
  Output,
  SkipSelf,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators
} from '@angular/forms';
import {Address} from 'src/app/models/address';
import {DropdownModel} from 'src/app/models/master/dropdown-model';
import {ActionType} from 'src/app/models/type/action.type.enum';
import {AddressType} from 'src/app/models/type/address.type.enum';
import {FormGroupBase} from 'src/app/shared/inputs/form-group-base';
import {InputDpDistrictComponent} from 'src/app/shared/inputs/input-dp-district/input-dp-district.component';
import {InputDpSubdistrictComponent} from 'src/app/shared/inputs/input-dp-subdistrict/input-dp-subdistrict.component';
import { TranstationFactory } from 'src/app/core/translation.factory';

@Component({
  selector: 'app-input-address',
  templateUrl: './input-address.component.html',
  styleUrls: ['./input-address.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputAddressComponent),
      multi: true
    }
  ]
})
export class InputAddressComponent extends FormGroupBase<any> implements OnInit, AfterViewInit {

  @Input() action: ActionType;
  @Input() exceptAddressType: Array<AddressType>;
  @Input() isShowAddressType = true;
  @Input() isLabelOnly = false;
  @Input() boxDpStyleClass: any = 'bg-white';
  @Input() btnDpStyleClass: any;
  @Input() addrLabel: Address;
  @Output() selectedDropdown: EventEmitter<Address> = new EventEmitter();
  @ViewChild(InputDpDistrictComponent) inpDistrictComp: InputDpDistrictComponent;
  @ViewChild(InputDpSubdistrictComponent) inpSubDistrictComp: InputDpSubdistrictComponent;
  labelPostcode : any ;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private fb: FormBuilder,
    private translate: TranstationFactory
  ) {
    super(cc);
  }

  get addrTypeDisabled(): boolean {
    return this.action === ActionType.Edit;
  }

  get province(): AbstractControl {
    return this.control.get('province');
  }

  get district(): AbstractControl {
    return this.control.get('district');
  }

  get subDistrict(): AbstractControl {
    return this.control.get('subdistrict');
  }

  get postcode(): AbstractControl {
    return this.control.get('postcode');
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.labelPostcode = this.translate.get('label.postcode');
    }, );
    this.checkInitialControl();
  }

  ngAfterViewInit(): void {
    if (!this.addrLabel) {
      this.addrLabel = new Address();
    }
    this.checkValueFormInit();
  }

  createForm(): FormGroup {
    return this.fb.group({
      'addressType': [],
      'address': [],
      'subdistrict': [],
      'district': [],
      'province': [],
      'postcode': []
    });
  }

  checkValidate(){
    this.control.get('addressType').markAsTouched();
    this.control.get('address').markAsTouched();
    this.province.markAsTouched();
    this.district.markAsTouched();
    this.subDistrict.markAsTouched();
    this.postcode.markAsTouched();
  }

  setValueToForm(addr: Address) {
    if (addr.type) {
      this.control.get('addressType').setValue(addr.type);
      this.control.get('address').setValue(addr.address);
      this.province.setValue(addr.province);
      this.district.setValue(addr.district);
      this.subDistrict.setValue(addr.subdistrict);
      this.postcode.setValue(addr.postalCode);
      this.checkValueFormInit();
    }
  }

  changedProvince(val: DropdownModel) {
    this.addrLabel.provinceName = val.label;
    this.clearDistrict();
    this.clearSubDistrict();
    this.clearPostCode();
    this.eventAddress();
    if (val.value) {
      this.inpDistrictComp.initDropdownList(val.value);
    }
  }

  changedDistrict(val: DropdownModel) {
    this.addrLabel.districtName = val.label;
    this.clearSubDistrict();
    this.clearPostCode();
    this.eventAddress();
    if (val.value) {
      this.inpSubDistrictComp.initDropdownList(val.value);
    }
  }

  changedSubDistrict(val: DropdownModel) {
    this.addrLabel.subdistrictName = val.label;
    this.eventAddress();
    if (val.value) {
      this.postcode.setValue(val.data.code);
    }
  }

  async checkValueFormInit() {
    if (this.province.value) {
      await this.inpDistrictComp.initDropdownList(this.province.value);
    }
    if (this.district.value) {
      await this.inpSubDistrictComp.initDropdownList(this.district.value);
    }
    if (this.subDistrict.value) {
      const subDistricts = this.inpSubDistrictComp.getDropdownArray().filter(item => {
        return item.value == this.subDistrict.value;
      });
      if (subDistricts) {
        const subDistrict: DropdownModel = subDistricts ? subDistricts[0].data.code : '';
        this.postcode.setValue(subDistrict);
      }
    }
  }

  private eventAddress() {
    this.selectedDropdown.emit(this.addrLabel);
  }

  private clearDistrict() {
    this.district.setValue(null);
    this.inpDistrictComp.resetDropdownList();
    this.addrLabel.districtName = '';
  }

  private clearSubDistrict() {
    this.subDistrict.setValue(null);
    this.inpSubDistrictComp.resetDropdownList();
    this.addrLabel.subdistrictName = '';
  }

  private clearPostCode() {
    this.postcode.setValue(null);
  }
}
